import React, { useContext, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import { AuthContext, AuthProvider } from './context/AuthContext';
import AccountantDash from './AccountantDash';
import AdminDash from './AdminDash';
import { create } from 'axios';
const axios = create();

const LoginContent = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const { setUser } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            // Backend call to verify MySQL DB User
            const res = await axios.post('https://fee.sdpdpublicschoolasr.in/api/login', { username, password });
            setUser({ role: res.data.role, name: res.data.name });
            navigate(res.data.role === 'Admin' ? '/admin' : '/accountant');
        } catch (err) {
            alert("Invalid Credentials! Check DB.");
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-100">
            <form onSubmit={handleLogin} className="bg-white p-8 rounded-2xl shadow-lg w-96 border-t-8 border-indigo-900">
                <h2 className="text-3xl font-extrabold mb-6 text-center text-indigo-950">SDPD Public School</h2>
                <div className="space-y-4">
                    <input type="text" placeholder="Username" value={username} onChange={e => setUsername(e.target.value)} className="w-full p-2.5 bg-slate-50 border rounded-lg outline-none" required />
                    <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} className="w-full p-2.5 bg-slate-50 border rounded-lg outline-none" required />
                </div>
                <button type="submit" className="w-full bg-indigo-700 text-white font-bold py-3 rounded-lg shadow-md mt-6">Login</button>
            </form>
        </div>
    );
};

const ProtectedRoute = ({ children, allowedRole }) => {
    const { user } = useContext(AuthContext);
    if (!user) return <Navigate to="/" replace />;
    if (user.role !== allowedRole) return <div className="p-10 text-red-600 font-bold text-center text-xl">⚠️ Unauthorized Access</div>;
    return children;
};

function App() {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<LoginContent />} />
                    <Route path="/accountant" element={<ProtectedRoute allowedRole="Accountant"><AccountantDash /></ProtectedRoute>} />
                    <Route path="/admin" element={<ProtectedRoute allowedRole="Admin"><AdminDash /></ProtectedRoute>} />
                </Routes>
            </Router>
        </AuthProvider>
    );
}
export default App;